module.exports = __webpack_public_path__ + "img/five-disabled-big.808d853c.svg";